import { EncampMailingAddress } from "encamp-shared/src/constants/encampAddress";

type NullableString = string | null | undefined;

export type MailingAddressSelection = true | false | "encamp" | null | undefined;

export type MailingAddressUpdates = {
  mailingStreetAddress1: string | null;
  mailingStreetAddress2: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  mailingCountry: string | null;
  mailingCompanyName: string | null;
};

type MailingAddressUpdateInput = {
  isMailingAddressSameAsFacility: MailingAddressSelection;
  previousIsMailingAddressSameAsFacility: MailingAddressSelection;
  streetAddress1: NullableString;
  streetAddress2: NullableString;
  city: NullableString;
  state: NullableString;
  zip: NullableString;
  country: NullableString;
  companyName: NullableString;
};

function normalizeString(value: NullableString): string | null {
  return value ?? null;
}

export function getMailingAddressUpdatesForSelection({
  isMailingAddressSameAsFacility,
  previousIsMailingAddressSameAsFacility,
  streetAddress1,
  streetAddress2,
  city,
  state,
  zip,
  country,
  companyName,
}: MailingAddressUpdateInput): MailingAddressUpdates | null {
  if (isMailingAddressSameAsFacility === "encamp") {
    return {
      mailingStreetAddress1: EncampMailingAddress.mailingStreetAddress1,
      mailingStreetAddress2: EncampMailingAddress.mailingStreetAddress2,
      mailingCity: EncampMailingAddress.mailingCity,
      mailingState: EncampMailingAddress.mailingState,
      mailingZip: EncampMailingAddress.mailingZip,
      mailingCountry: EncampMailingAddress.mailingCountry,
      mailingCompanyName: normalizeString(companyName),
    };
  }

  if (isMailingAddressSameAsFacility === true) {
    return {
      mailingStreetAddress1: normalizeString(streetAddress1),
      mailingStreetAddress2: normalizeString(streetAddress2),
      mailingCity: normalizeString(city),
      mailingState: normalizeString(state),
      mailingZip: normalizeString(zip),
      mailingCountry: normalizeString(country),
      mailingCompanyName: normalizeString(companyName),
    };
  }

  if (
    isMailingAddressSameAsFacility === false &&
    previousIsMailingAddressSameAsFacility != null &&
    previousIsMailingAddressSameAsFacility !== false
  ) {
    return {
      mailingStreetAddress1: null,
      mailingStreetAddress2: null,
      mailingCity: null,
      mailingState: null,
      mailingZip: null,
      mailingCountry: null,
      mailingCompanyName: null,
    };
  }

  return null;
}
